export const NOTIFICATION_LABELS = {
  title: 'Notifications',
  description: 'Manage notifications',
  searchPlaceholder: 'Search notifications',
  noNotifications: 'No notifications available',
  viewDetails: 'View details',
  deleteAction: 'Delete notification',
  addNotificationAction: 'Add Notification',
  createdOnPrefix: 'Created:',
};

/** Default number of notifications per page */
export const DEFAULT_NOTIFICATION_PAGE_SIZE = 5;

/** Available page size options */
export const PAGE_NOTIFICATION_SIZE_OPTIONS = [5, 10, 25, 50];

/** Display names for notification countries  */
export const NOTIFICATION_COUNTRY_DISPLAY_GROUPS: Readonly<Record<number, readonly string[]>> = {
  1: ['Australia'],
  2: ['New Zealand'],
  3: ['Australia', 'New Zealand'],
} as const;

/** Aliases normalized to display names for API country strings. */
export const NOTIFICATION_COUNTRY_NAME_NORMALIZATION: Readonly<Record<string, string>> = {
  australia: 'Australia',
  au: 'Australia',
  'new zealand': 'New Zealand',
  nz: 'New Zealand',
} as const;

// Add Notification modal

/** UI labels */
export const ADD_NOTIFICATION_LABELS = {
  MODAL_TITLE: 'Add Notification',
  FORM_ARIA_LABEL: 'Add notification form',
  REGION_LABEL: 'Region',
  REGION_PLACEHOLDER: 'Select Region',
  REGION_SELECT_ALL: 'All Regions',
  TITLE_LABEL: 'Title',
  TITLE_PLACEHOLDER: 'Enter title',
  DESCRIPTION_LABEL: 'Description',
  DESCRIPTION_PLACEHOLDER: 'Enter description',
  DESCRIPTION_HINT: 'Max description length size 200 characters.',
  DONE: 'Done',
  CANCEL: 'Cancel',
  ADD: 'Add',
  EDIT_MODAL_TITLE: 'Edit Notification',
  SAVE: 'Save',
} as const;

/**
 * Region options keyed to NOTIFICATION_COUNTRY_IDS values.
 * Kept as plain value/label pairs so they can also feed CommonSelectBarComponent.
 */
export const ADD_NOTIFICATION_REGION_OPTIONS: ReadonlyArray<{ value: string; label: string }> = [
  { value: '1', label: 'Australia' },
  { value: '2', label: 'New Zealand' },
] as const;

// Confirm Delete Notification modal
/** UI labels sourced from */
export const CONFIRM_DELETE_NOTIFICATION_LABELS = {
  MODAL_TITLE: 'Confirm Delete',
  MESSAGE_PREFIX: 'Are you sure you want to delete',
  MESSAGE_SUFFIX: 'Notification?',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
  DELETE_ICON_ARIA_LABEL: 'Delete notification icon',
} as const;

/** Fallback title when a specific notification title is unavailable. */
export const CONFIRM_DELETE_NOTIFICATION_DEFAULTS = {
  FALLBACK_NOTIFICATION_TITLE: 'this notification',
} as const;

// Create Notification API defaults
/** Fixed API payload values used when POSTing a new notification. */
export const CREATE_NOTIFICATION_API_DEFAULTS = {
  /** General notification type used when no specific type is selected. */
  NOTIFICATION_TYPE_ID: 1,
  /** No banner attached by default. */
  BANNER_ID: 0,
} as const;

/** Error messages shown in the Add Notification modal. */
export const ADD_NOTIFICATION_ERROR_MESSAGES = {
  REGION_REQUIRED: 'Region is required.',
  TITLE_REQUIRED: 'Title is required.',
  DESCRIPTION_REQUIRED: 'Description is required.',
  DESCRIPTION_JAVASCRIPT: 'Content cannot contain script tags, event handlers, or JavaScript code.',
  SUBMIT_FAILED: 'Failed to create notification. Please try again.',
  UPDATE_FAILED: 'Failed to update notification. Please try again.',
} as const;

/** Error messages shown in the Confirm Delete Notification modal. */
export const DELETE_NOTIFICATION_ERROR_MESSAGES = {
  SUBMIT_FAILED: 'Failed to delete notification. Please try again.',
} as const;
